import { v4 as uuid } from 'uuid';

export const ADD_OR_UPDATE_SHIPPING_GROUP = 'mallfront/shipping/ADD_OR_UPDATE_SHIPPING_GROUP';
export const REMOVE_SHIPPING_GROUP = 'mallfront/shipping/REMOVE_SHIPPING_GROUP';
export const CLEAR_SHIPPING_GROUPS = 'mallfront/shipping/CLEAR_SHIPPING_GROUPS';

const initialState = {};


export const shippingReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_OR_UPDATE_SHIPPING_GROUP: {
            const uid = action.shippingGroup.id || uuid();
            return {
                ...state,
                [uid]: { ...action.shippingGroup, id: uid }
            };
        }
        case REMOVE_SHIPPING_GROUP: {
            const { [action.shippingGroup.id]: value, ...remainder } = state;
            return remainder;
        }
        case CLEAR_SHIPPING_GROUPS: {
            return {};
        }
        default:
            return state;
    }
};


export const addOrUpdateShippingGroup = shippingGroup => ({
    type: ADD_OR_UPDATE_SHIPPING_GROUP,
    shippingGroup
});

export const removeShippingGroup = shippingGroup => ({
    type: REMOVE_SHIPPING_GROUP,
    shippingGroup
});

export const clearShippingGroups = () => ({
    type: CLEAR_SHIPPING_GROUPS
});
